/* eslint-disable no-nested-ternary, react/jsx-no-duplicate-props */

import TextField from '@material-ui/core/TextField'
import { Close, Help, Lock } from '@material-ui/icons'
import cn from 'classnames'
import React, { PureComponent } from 'react'
import handleOnClickOutside from 'react-onclickoutside'
import { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import IconButton from '../IconButton'
import LabelWrapper from '../LabelWrapper'
import './textField_overrides.css'

class inputField extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { isHover: false, isFocus: false }
    this.onFocus = this.onFocus.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onHover = this.onHover.bind(this)
    this.onHoverOut = this.onHoverOut.bind(this)
    this.onClick = this.onClick.bind(this)
    this.handleOnClickIcon = this.handleOnClickIcon.bind(this) || (() => {})
    this.onChange = this.onChange.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)
  }

  onClick() {
    const { onClick } = this.props
    if (onClick) {
      onClick()
    }
  }

  onHover() {
    this.setState({
      isHover: true,
    })
  }

  onHoverOut() {
    this.setState({
      isHover: false,
    })
  }

  onFocus() {
    this.setState({
      isFocus: true,
    })
    const { onFocus } = this.props
    onFocus()
  }

  onSubmit() {
    this.setState({
      isFocus: false,
    })
    const { onSubmit } = this.props
    onSubmit()
  }

  onKeyPress(event) {
    this.setState({
      isFocus: false,
    })
    const { onKeyPress } = this.props
    if (onKeyPress) {
      onKeyPress(event)
    }
  }

  onBlur() {
    this.setState({
      isFocus: false,
    })
    const { onBlur } = this.props
    onBlur()
  }

  onChange(value) {
    const { onChange } = this.props
    onChange(value)
  }

  handleClickOutside = e => {
    const { handleOnClickOutside } = this.props
    handleOnClickOutside(e)
  }

  onClickActionLink = () => {
    const { onClickActionLink } = this.props
    onClickActionLink()
  }

  handleOnClickIcon() {
    const { handleOnClickIcon, isClearable, handleOnClear } = this.props
    if (isClearable && handleOnClear) {
      handleOnClear()
      return
    }

    if (handleOnClickIcon) {
      handleOnClickIcon()
    }
  }

  render() {
    const {
      actionLabel,
      actionLink,
      actionLinkTestId,
      asTrigger,
      autoFocus,
      children,
      childrenAfterInput,
      childrenBeforeInput,
      className,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      dataTestId,
      defaultValue,
      disableIconClick,
      disabled,
      errorText,
      fullWidth,
      hasError,
      helperText,
      helperTextRight,
      hoverBg,
      icon,
      iconHover,
      id,
      inputClassName,
      inputProps,
      inputRef,
      isClearable,
      isLabelInline,
      isRequired,
      isToolTip,
      label,
      labelIcon,
      multipleFields,
      name,
      noMobile,
      noSpacing,
      noWrap,
      notWrapper,
      onClick,
      onKeyPress,
      placeholder,
      prefix,
      showActionLink,
      showNoValue,
      spacing,
      step,
      subField,
      suffix,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      type,
      value,
      willDelete,
      withBorder,
      withDivider,
      ...rest
    } = this.props
    const { isHover, isFocus } = this.state

    let inputFieldComponent = null

    if (children) {
      inputFieldComponent = <div className="has-children">{children}</div>
    } else {
      let InputIcon = icon
      if (iconHover && isHover) {
        InputIcon = iconHover
      }
      if (isClearable) {
        InputIcon = value.length > 0 ? <Close style={{ fontSize: 14 }} /> : null
      }
      if (disableIconClick) {
        InputIcon = <Lock />
      }
      inputFieldComponent = (
        <React.Fragment>
          <TextField
            inputRef={inputRef}
            defaultValue={defaultValue}
            fullWidth={fullWidth}
            disabled={asTrigger ? false : !!onClick || disabled || willDelete}
            onBlur={this.onBlur}
            onClick={asTrigger && onClick}
            onChange={this.onChange}
            onSubmit={this.onSubmit}
            onFocus={this.onFocus}
            onKeyPress={this.onKeyPress}
            value={showNoValue ? '' : value}
            placeholder={placeholder}
            className={cn(
              {
                'active-field': isFocus,
                'click-field': onClick,
                disabled,
                willDelete,
              },
              'custom-textfield'
            )}
            type={type}
            autoFocus={autoFocus}
            style={{
              ...(customWidth ? { width: `${customWidth}px` } : {}),
              ...(asTrigger ? { caretColor: 'transparent' } : {}),
            }}
            id={`${id}-input`}
            name={name}
            inputProps={{
              className: hoverBg && 'input-hover',
              'data-testid': dataTestId,
              ...inputProps,
            }}
            InputProps={{
              startAdornment: prefix && <div className="prefix">{prefix}</div>,
              endAdornment: suffix ? (
                <div className="suffix">{suffix}</div>
              ) : InputIcon ? (
                <IconButton
                  className="input-icon"
                  onClick={!disableIconClick && this.handleOnClickIcon}
                  icon={InputIcon}
                  size="small"
                  tabIndex="-1"
                  disabled={disableIconClick}
                  disableRipple={disableIconClick}
                  aria-label={actionLabel}
                />
              ) : null,
              ...(step && { step }),
            }}
            data-error-key={hasError ? id : undefined}
            // eslint-disable-next-line react/jsx-no-duplicate-props
          />
          {helperTextRight && <p className="helper-text">{helperTextRight}</p>}
        </React.Fragment>
      )
    }
    return (
      <ThemeProvider theme={theme}>
        <LabelWrapper
          actionLink={actionLink}
          actionLinkTestId={actionLinkTestId}
          className={className}
          customCol={customCol}
          customMargin={customMargin}
          customPadding={customPadding}
          customWidth={customWidth}
          disabled={disabled}
          disableIconClick={disableIconClick}
          errorText={errorText}
          fullWidth={fullWidth}
          helperText={helperText}
          id={id}
          inputClassName={inputClassName}
          isLabelInline={isLabelInline}
          isRequired={isRequired}
          isToolTip={isToolTip}
          label={label}
          labelIcon={labelIcon}
          multipleFields={multipleFields}
          noMobile={noMobile}
          noSpacing={noSpacing}
          notWrapper={notWrapper}
          noWrap={noWrap}
          onClick={onClick}
          onClickActionLink={this.onClickActionLink}
          onMouseEnter={this.onHover}
          onMouseLeave={this.onHoverOut}
          showActionLink={showActionLink}
          spacing={spacing}
          subField={subField}
          toolTipIcon={toolTipIcon}
          toolTipIconColor={toolTipIconColor}
          toolTipIconSize={toolTipIconSize}
          toolTipPosition={toolTipPosition}
          toolTipText={toolTipText}
          willDelete={willDelete}
          withBorder={withBorder}
          withDivider={withDivider}
          {...rest}
        >
          {childrenBeforeInput && childrenBeforeInput}
          {inputFieldComponent}
          {childrenAfterInput && childrenAfterInput}
        </LabelWrapper>
      </ThemeProvider>
    )
  }
}

inputField.defaultProps = {
  actionLabel: 'Button',
  handleOnClickOutside: () => {},
  onChange: () => {},
  onFocus: () => {},
  onSubmit: () => {},
  onBlur: () => {},
  handleOnClickIcon: () => {},
  handleOnClear: () => {},
  disabled: false,
  onClick: null,
  label: '',
  isRequired: false,
  isClearable: false,
  customWidth: null,
  hasError: false,
  errorText: '',
  helperText: '',
  id: '',
  icon: null,
  isLabelInline: false,
  placeholder: '',
  type: '',
  iconHover: null,
  labelIcon: null,
  disableIconClick: false,
  autoFocus: false,
  noMobile: false,
  notWrapper: true,
  fullWidth: true,
  withBorder: false,
  inputProps: {},
  isToolTip: false,
  toolTipIcon: <Help className="toolTipIcon" />,
  toolTipText: 'why this?',
  toolTipIconSize: 16,
  toolTipIconColor: '',
  toolTipPosition: 'top',
  withDivider: false,
  showNoValue: false,
}

const InputField = handleOnClickOutside(inputField)
InputField.displayName = 'InputField'
export default InputField
